<template>
  <div id="footTips">
    <div class="footDesc">
      <p class="animated" v-scroll-class="'swing'">诚信第一、质量第一、科学公正、优质服务</p>
    </div>
    <div style="padding: 0 20px; box-sizing: border-box;display: flex;flex-wrap: wrap;justify-content: center; align-items: center;">
      <h1 style="margin: 10px; overflow: hidden; display: flex;flex-direction: column; justify-content: center; align-items: center;font-size: 2em;">
        <img style="width: 100px;height: 100px; transform-origin: center center; margin-bottom: 10px;" src="@/assets/images/logo/pufeite.png" alt="鄂尔多斯市安能检测检验有限公司">
        <span style="font-size: 14px; display: block;">鄂尔多斯市安能检测检验有限公司</span>
      </h1>
      <ul style="margin: 10px; display: block; list-style-type: disc; margin-block-start: 1em;  margin-block-end: 1em; padding-inline-start: 40px; unicode-bidi: isolate;">
        <li style="display: list-item; text-align: -webkit-match-parent;unicode-bidi: isolate;">联系方式</li>
        <li style="display: list-item; text-align: -webkit-match-parent;unicode-bidi: isolate;">地址：内蒙古自治区鄂尔多斯市东胜区天骄北路11号金辉大厦6号楼5层03、04</li>
        <li style="display: list-item; text-align: -webkit-match-parent;unicode-bidi: isolate;">电话：15147789878</li>
        <li style="display: list-item; text-align: -webkit-match-parent;unicode-bidi: isolate;">邮箱：2727864284@qq.com</li>
      </ul>
    </div>
    <div class="aq">
      <h2>鄂尔多斯市安能检测检验有限公司</h2>
<!--      <span>苏ICP备2021016579号-1</span>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'footTips'
}
</script>

<style lang="less" scoped>
  @media screen and (min-width: 1200px) {
    #footTips  .footContainer {
      width: 1200px;
      margin: 0 auto;
    }
    #footTips .aq {
      padding-bottom: 10px;
    }
  }
  @media screen and (max-width: 1200px) {
    #footTips .footContainer {
      width: 100%;
    }

    #footTips .aq {
      padding-bottom: 68px;
    }
  }
  #footTips {
    margin-top: 60px;
    background-color: #292929;
    color: #fff;

    .footDesc {
      background: url("../../assets/images/bg-ad.png") 100% 100%;
      background-repeat: no-repeat;
      background-position: center top;
      background-size: 100% 100%;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      font-size: 20px;
      color: #fff;

      p {
        text-align: center;
        padding: 0 20px;
        line-height: 30px;
      }
    }

    .footContainer {
      padding: 0 20px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      h1 {
        // width: 160px;
        // height: 160px;
        margin: 10px;
        overflow: hidden;
        //display: flex;
        //flex-direction: column;
        //justify-content: center;
        img {
          // width: 100%;
          height: 50px;
          transform-origin: center center;
          // margin-top: -15px;
        }

        span {
          font-size: 14px;
          display: block;
        }
      }
      ul {
        margin: 10px;
        li:first-child {
          font-weight: bold;
          margin-bottom: 20px;
        }
        li {
          margin: 10px 0;
        }
      }
      img {
        width: 160px;
        height: 160px;
      }
      a {
        color: #fff;
      }
    }

    .aq {
      display: flex;
      justify-content: center;
      background: #212121;
      padding-top: 10px;

      h2 {
        font-size: 12px;
        margin: 0;
        padding: 0;
        color: #808080;
      }
      span {
        font-size: 12px;
        margin: 0;
        padding: 0;
        margin-left: 10px;
      }
    }
  }
</style>
